import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

interface ChartErrorMessageProps {
  children: ReactNode;
  message: string;
}

const MESSAGE_HEIGHT = 32;

export default function ChartErrorMessage({children, message}: ChartErrorMessageProps): JSX.Element {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.message)}>
        <InlineBanner bannerType={InlineBannerType.ERROR} text={message} />
      </div>
      <div className={css(styles.chart)}>{children}</div>
    </div>
  );
}

export const styles = StyleSheet.create({
  chart: {
    height: '100%',
    width: '100%',
  },
  container: {
    height: '100%',
    paddingBottom: MESSAGE_HEIGHT,
    width: '100%',
  },
  message: {
    height: MESSAGE_HEIGHT,
  },
});
